import React from 'react';

const Clients: React.FC = () => {
  return (
    <section id="clients" className="clients-section">
      <div className="container">
        <h2>Our Clients</h2>
        <div className="client-logos">
        <img src="/client_2.png" alt="Client 6" className="client-logo" />
          <img src="/client_1.png" alt="Client 6" className="client-logo" />
          <img src="/client_3.png" alt="Client 6" className="client-logo" />
        </div>
      </div>
    </section>
  );
};

export default Clients; 